import { useSignal } from '@preact/signals';
import { MessengerButton, type MessageState } from 'components/offer/MessengerButton';
import { type OfferData } from 'service/offer/model';
import type { OfferRooms } from 'service/offer/resource';
import { Messenger } from 'lib/messenger/Messenger';
import { ClockLoader } from 'components/atoms/spinner/ClockLoader';
import { offersAndRooms } from 'components/bazar/signals';

export function MessengerButtonContainer({ className, offer }: { className: string; offer: OfferData }) {
	const offerRooms = getOfferRooms(offer.id, offersAndRooms.value);
	const state = getMessageState(offerRooms);
	const isLoading = useSignal(false);

	if (state === 'NONE') return <></>;

	return (
		<div className={className}>
			{isLoading.value ? (
				<ClockLoader size={40} />
			) : (
				<MessengerButton
					isWithBg
					state={state}
					onClick={() => {
						isLoading.value = true;

						const messengerPromise =
							offerRooms?.messengerRooms.length === 1 && offerRooms.messengerRooms[0]?.roomId
								? Messenger.openRoom(offerRooms.messengerRooms[0]?.roomId)
								: Messenger.openGroup(String(offer.id));

						messengerPromise
							.catch(() => {
								Messenger.showErrorToast();
							})
							.finally(() => {
								isLoading.value = false;
							});
					}}
				/>
			)}
		</div>
	);
}

function getOfferRooms(offerId: string | number, advertsAndRooms: OfferRooms[]) {
	return advertsAndRooms.find(({ advertId }) => String(advertId) === String(offerId));
}

function getMessageState(offerRooms: OfferRooms | undefined): MessageState {
	if (!offerRooms) return 'NONE';
	return offerRooms.unreadRooms ? 'UNREAD' : 'READ';
}
